import React, { useEffect, useState } from 'react';
import './../styles/TokenExpiryModal.css';

const TokenExpiryModal = ({ show, onRelogin, onLogout, timeLeft }) => {
  const [countdown, setCountdown] = useState(Math.floor(timeLeft / 1000));

  useEffect(() => {
    if (!show) return;

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          handleLogout(); // Автоматический logout когда время истекло
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [show]);

  useEffect(() => {
    setCountdown(Math.floor(timeLeft / 1000));
  }, [timeLeft]);

  const handleRelogin = () => {
    onRelogin();
    // Навигация будет выполнена в родительском компоненте
  };

  const handleLogout = () => {
    onLogout();
    // Навигация будет выполнена в родительском компоненте
  };

  if (!show) return null;

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="token-expiry-overlay">
      <div className={`token-expiry-modal ${countdown <= 60 ? 'urgent' : ''}`}>
        <div className="modal-icon">
          ⏰
        </div>
        <h2>Сессия истекает</h2>
        <p>
          Ваша сессия истечет через <strong>{formatTime(countdown)}</strong>
        </p>
        <p className="modal-subtitle">
          Пожалуйста, войдите в систему заново для продолжения работы
        </p>
        
        <div className="modal-actions">
          <button 
            onClick={handleRelogin}
            className="relogin-button"
          >
            <span>🔄</span>
            Войти заново
          </button>
          <button 
            onClick={handleLogout}
            className="logout-button"
          >
            <span>🚪</span>
            Выйти
          </button>
        </div>
        
        <div className="progress-bar">
          <div 
            className="progress-fill"
            style={{ 
              width: `${(countdown / (timeLeft / 1000)) * 100}%`,
              transition: 'width 1s linear'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TokenExpiryModal;